import React, { useEffect, useState } from "react";
// import React, { useEffect } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import AllEntriesForm from "./allEntriesForm";
import TableComponent from "./Table";
import ContactedLeads from "./ContactedLeads";
import KanbanViewLeads from "./Kanaban";
import TableGrouped from "./TableGrouped";
import axios from "axios";
import { format } from "date-fns";

import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  ButtonGroup,
} from "@mui/material";

import kanban from "../utils/kanban.png";
import table from "../utils/mainTable.svg";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";


const Leads = () => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
  };



  const [messageForUser, setMessageForUser] = useState(null);
  const [rows, setRows] = useState(() => {
    const savedData = localStorage.getItem("leadTableData");
    return savedData ? JSON.parse(savedData) : [];
  });


  // console.log('rows from leads:',rows)
  // useEffect(() => {
  //   localStorage.setItem("leadTableData", JSON.stringify(rows));
  // }, [rows]);
  // console.log('rows:',rows)
  const handleFormSubmit = (formData) => {
    const existingLead = rows.find((row) => row.id === formData.id); // Find the existing lead by ID

    const newHistory = [];

    if (existingLead) {
      // Compare each field and add to history if it has changed
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== existingLead[key]) {
          newHistory.push({
            date: new Date().toISOString(), // Record the timestamp
            activity: `Field "${key}" updated`,
            note: `Changed from "${existingLead[key]}" to "${formData[key]}"`,
          });
        }
      });

      // Update the existing lead with new data and updated history
      const updatedLead = {
        ...existingLead,
        ...formData,
        leadTimeline: [...existingLead.leadTimeline, ...newHistory], // Append new history entries
      };

      setRows(rows.map((row) => (row.id === formData.id ? updatedLead : row)));
    } else {
      const newRow = {
        // id: rows.length + 1, // Unique ID for each row
        id: formData.id, // Unique ID for each row
        // lead: formData.name,
        lead: 'newLead',
        // lead: formData.lead,
        status: formData.status,
        organization: formData.organization,
        title: formData.title,
        email: formData.email,
        phone: formData.phone,
        isPhoneWhatsApp: formData.isPhoneWhatsApp,
        alternatePhone: formData.alternatePhone,
        isAlternatePhoneWhatsApp: formData.isAlternatePhoneWhatsApp,
        notes: 'Need Products',
        // notes: formData.notes,
        leadSource: formData.leadSource,
        coordinator: formData.coordinator,
        assignTo: formData.assignTo,
        docs: formData.docs,
        campaignId: formData.campaignId,
        departmentNo: formData.departmentNo,

        // leadDateAndTimeEntry: formData.leadDateAndTimeEntry,
        probability: formData.probability,
        bookedAmount: formData.bookedAmount,
        territory: formData.territory,
        country: formData.country,
        streetAddress: formData.streetAddress,
        city: formData.city,
        apartment: formData.apartment,
        location: formData.location,
        area: formData.area,
        priority: formData.priority,
        leadEntryTime: formData.leadEntryTime,
        leadTimeline: formData.timeline,
        leadItemCode: formData.itemCode,
        leadIsItemAdded: formData.isItemAdded,
        leadItemDescription: formData.itemDescription,
        leadItemUnit: formData.itemUnit,
        leadItemCurrentStock: formData.itemCurrentStock,
        leadItemQuantity: formData.itemQuantity,
        leadItemPrice: formData.itemPrice,
        leadItemAmount: formData.itemAmount,
      };
      setRows([...rows, newRow]); // Add the new row to the table
    }
    // console.log('leadIsItemAdded from leads',leadIsItemAdded)
  };

  const [viewMode, setViewMode] = useState("Tabular"); // View mode state
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });
  // console.log('rows:in leads',rows)
  const groupedRows = rows.reduce((acc, row) => {
    acc[row.lead_status] = acc[row.lead_status] || [];
    acc[row.lead_status].push(row);
    return acc;
  }, {});


  const [toEditLead, setToEditLead] = useState('')

  const callAPIToSaveData = (dataForAPI, productEntries) => {

    console.log("callAPIToSaveData >> ", dataForAPI);
    console.log("callAPIToSaveData >>", productEntries);

    let arrayWeHaveToGiveToAPI = [];

    if (productEntries.length > 0) {
      arrayWeHaveToGiveToAPI = productEntries.map((product, index) => {

        return {
          CmpCode: company_code_from_local_storage,
          mode: "EDIT",

          lead_id: dataForAPI.lead_id + "",
          lead_entryTime: format(new Date(), "yyyy-MM-dd"),
          lead_creatorid: dataForAPI.lead_creatorid?.trim(),
          lead_coordinator: dataForAPI.lead_coordinator?.trim(),
          lead_salesperson: dataForAPI.lead_salesperson?.trim(), //
          lead_teamid: dataForAPI.lead_teamid,
          lead_CampaignId: dataForAPI.lead_CampaignId,
          lead_account: dataForAPI.lead_account,
          lead_organization: dataForAPI.lead_organization,
          lead_notes: dataForAPI.lead_notes,
          lead_country: dataForAPI.lead_country,
          lead_city: dataForAPI.lead_city,
          lead_territory: dataForAPI.lead_territory,
          lead_area: dataForAPI.lead_area,
          lead_streetaddress: dataForAPI.lead_streetaddress,
          lead_location: dataForAPI.lead_location,
          lead_appartment: dataForAPI.lead_appartment,
          lead_primarycontact: dataForAPI.lead_primarycontact,
          lead_primarycontacttitle: dataForAPI.lead_primarycontacttitle,
          lead_phone: dataForAPI.lead_phone,
          lead_isphonewhatsapp: dataForAPI.lead_isphonewhatsapp,
          lead_alt_phone: dataForAPI.lead_alt_phone, //
          lead_alt_isphonewhatsapp: dataForAPI.lead_alt_isphonewhatsapp, //
          lead_email: dataForAPI.lead_email, //
          lead_stage: dataForAPI.lead_stage, //
          lead_probability: dataForAPI.lead_probability, //
          // lead_probability: Number(dataForAPI.probability), //
          lead_priority: dataForAPI.lead_priority,
          // lead_priority: getPriorityName(dataForAPI.priority),
          lead_source: dataForAPI.lead_source, //
          lead_status: dataForAPI.lead_status, //
          lead_assignedto: dataForAPI.lead_assignedto, //
          lead_bookedamount: Number(dataForAPI.lead_bookedamount), //
          lead_currencycode: dataForAPI.lead_currencycode, //
          lead_currencyrate: dataForAPI.lead_currencyrate, //
          deptno: dataForAPI.deptno, //

          prod_code: product.itemCode, //
          prod_Description: product.itemDescription, //
          prod_Unit: product.itemUnit || "0", //
          // prod_Qty: Number(product.itemQuantity) || 0, //
          prod_Qty: product.itemQuantity || "0", //
          // prod_Price: Number(product.itemPrice) || 0, //
          prod_Price: product.itemPrice || 0, //
          // prod_Amount:
          //   (Number(product.itemQuantity) || 0) *
          //   (Number(product.itemPrice) || 0), //
          prod_Amount: 0, //
          prod_Comments: "", //
          prod_imagepath: "", //
        };
      });
    } else {
      arrayWeHaveToGiveToAPI = [
        {
          CmpCode: company_code_from_local_storage,
          mode: "EDIT",

          lead_id: dataForAPI.lead_id + "",
          lead_entryTime: format(new Date(), "yyyy-MM-dd"),
          lead_creatorid: dataForAPI.lead_creatorid?.trim(),
          lead_coordinator: dataForAPI.lead_coordinator?.trim(),
          lead_salesperson: dataForAPI.lead_salesperson?.trim(), //
          lead_teamid: dataForAPI.lead_teamid,
          lead_CampaignId: dataForAPI.lead_CampaignId,
          lead_account: dataForAPI.lead_account,
          lead_organization: dataForAPI.lead_organization,
          lead_notes: dataForAPI.lead_notes,
          lead_country: dataForAPI.lead_country,
          lead_city: dataForAPI.lead_city,
          lead_territory: dataForAPI.lead_territory,
          lead_area: dataForAPI.lead_area,
          lead_streetaddress: dataForAPI.lead_streetaddress,
          lead_location: dataForAPI.lead_location,
          lead_appartment: dataForAPI.lead_appartment,
          lead_primarycontact: dataForAPI.lead_primarycontact,
          lead_primarycontacttitle: dataForAPI.lead_primarycontacttitle,
          lead_phone: dataForAPI.lead_phone,
          lead_isphonewhatsapp: dataForAPI.lead_isphonewhatsapp,
          lead_alt_phone: dataForAPI.lead_alt_phone, //
          lead_alt_isphonewhatsapp: dataForAPI.lead_alt_isphonewhatsapp, //
          lead_email: dataForAPI.lead_email, //
          lead_stage: dataForAPI.lead_stage, //
          lead_probability: dataForAPI.lead_probability, //
          // lead_probability: Number(dataForAPI.probability), //
          lead_priority: dataForAPI.lead_priority,
          // lead_priority: getPriorityName(dataForAPI.priority),
          lead_source: dataForAPI.lead_source, //
          lead_status: dataForAPI.lead_status, //
          lead_assignedto: dataForAPI.lead_assignedto, //
          lead_bookedamount: Number(dataForAPI.lead_bookedamount), //
          lead_currencycode: dataForAPI.lead_currencycode, //
          lead_currencyrate: dataForAPI.lead_currencyrate, //
          deptno: dataForAPI.deptno, //

          prod_code: "",
          prod_Description: "",
          prod_Unit: "",
          prod_Qty: 0,
          prod_Price: 0,
          prod_Amount: 0,
          prod_Comments: "",
          prod_imagepath: "",
        },
      ];
    }
    const jsonToSend = JSON.stringify(arrayWeHaveToGiveToAPI);


    console.log("json to send to LEAD REGISTER", jsonToSend);


    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRM_LeadRegister`;

    axios
      .post(apiUrl, jsonToSend, {
        headers: {
          // Overwrite Axios's automatically set Content-Type
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("res is ", dataForAPI);
        setOpenSubmitSnackbar(true); // Show success snackbar


        if (res.data.result == "Saved") {
          setMessageForUser({
            result: "success",
            title: "Success",
            message: "Successfully Saved",
          });
          console.log("success");


        } else {
          setMessageForUser({
            result: "failure",
            title: "Error",
            message: "Could not save, something went wrong",
          });
          console.log("failure");
        }
      })
      .catch((err) => {
        console.log("error while posting lead", err.response.data);
      });

  }

  const onEditLead = (toEditLeadData) => {

    console.log('toEditLeadData:', toEditLeadData)
    setToEditLead(toEditLeadData); // Store lead data for form
    setValue("2"); // Switch to "Lead Form" tab
  };

  const onEditLeadFromViewLead = (toEditLeadData, productsList) => {

    callAPIToSaveData(toEditLeadData, productsList);

  };

  const clickedOnEditLead = (dataForAPI, productsList) => {

    console.log('clickedOnEditLead lead details >>', dataForAPI)
    console.log('clickedOnEditLead product details >>', productsList)



    const initialFormData = {
      isEditinglead:true,
      account:dataForAPI.lead_account,
      id: dataForAPI.lead_id + "",
      lead: dataForAPI.lead_primarycontact,
      phone: dataForAPI.lead_phone,
      alternatePhone: dataForAPI.lead_alt_phone, //
      isPhoneWhatsApp: dataForAPI.lead_isphonewhatsapp,
      isAlternatePhoneWhatsApp: dataForAPI.lead_alt_isphonewhatsapp, //
      status: dataForAPI.lead_status, //
      organization: dataForAPI.lead_organization,
      title: dataForAPI.lead_primarycontacttitle,
      email: dataForAPI.lead_email, //
      notes: dataForAPI.lead_notes,
      leadSource: dataForAPI.lead_source, //
      coordinator: dataForAPI.lead_coordinator?.trim(),
      salesperson: dataForAPI.lead_salesperson?.trim(), //
      assignTo: dataForAPI.lead_assignedto, //
      docs: "",
      campaignId: dataForAPI.lead_CampaignId,
      departmentNo: dataForAPI.deptno, //
      probability: dataForAPI.lead_probability, //
      currency: dataForAPI.lead_currencycode, //
      bookedAmount: dataForAPI.lead_bookedamount, //
      territory: dataForAPI.lead_territory,
      country: dataForAPI.lead_country,
      streetAddress: dataForAPI.lead_streetaddress,
      city: dataForAPI.lead_city,
      apartment: dataForAPI.lead_appartment,
      location: dataForAPI.lead_location,
      area: dataForAPI.lead_area,
      priority: dataForAPI.lead_priority,
      leadEntryTime: format(new Date(), "yyyy-MM-dd"),
      timeline: "",
      isItemAdded: "",
      itemCode: "",
      itemDescription: "",
      itemUnit: "",
      itemCurrentStock: "",
      itemQuantity: "",
      itemPrice: "",
      itemAmount: "",
    };

    console.log('clickedOnEditLead received details >>', initialFormData)
    localStorage.setItem("currentEditingLeadForm", JSON.stringify(initialFormData))
    localStorage.setItem("currentEdittingProductsList", JSON.stringify(productsList))

    setValue("2"); // Switch to "Lead Form" tab
  }

  const onEditCancelLead = (toEditLeadData) => {
    setToEditLead(null); // Store lead data for form
    setValue("1"); // Switch to "Lead Form" tab
  };



  return (
    <div className="text-sm font-thin px-2">
      <ThemeProvider theme={theme}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="">
              <Tab label="Main Table" value="1" />
              <Tab label="Lead Form" value="2" />
            </TabList>
          </Box>

          <TabPanel sx={{ padding: "0px 6px 0px 6px" }} value="1">
            <TableComponent
              rows={rows}
              setRows={setRows}
              groupedRows={groupedRows}
              onEditLead={onEditLead}
              onEditLeadFromViewLead={onEditLeadFromViewLead}
              clickedOnEditLead={clickedOnEditLead}
              setValue={setValue}
            />
          </TabPanel>
          <TabPanel
            sx={{ marginTop: "12px", padding: "0px 6px 0px 6px" }}
            value="2"
          >
            <AllEntriesForm onFormSubmit={handleFormSubmit} toEditLead={toEditLead} onEditCancelLead={onEditCancelLead} />
          </TabPanel>
        </TabContext>
      </ThemeProvider>

      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          severity="success"
          sx={{ width: "100%" }}
        >
          Lead Edit Successfully!
        </MuiAlert>
      </Snackbar>

    </div>
  );
};

export default Leads;
